import { injectable } from 'inversify';

import { IStatesRepository } from '@/domain/repositories/get-states.repository.interface';
import { Result } from '@/entities/Result';
import { statesDtoToStates } from '@/infrastructure/mapper/state-mapper';
import { getStates } from '@/infrastructure/network/data/states';
import { StatesResponse } from '@/infrastructure/network/dto/StateDto';

@injectable()
export class StatesRepository implements IStatesRepository {
	async getStates(countryId?: string): Promise<Result<StatesResponse>> {
		const result = await getStates({ countryId });
		if (result.statusCode === 200) {
			return { data: statesDtoToStates(result.data), statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}
}
